$(document).ready(function () {
  let menu_open = false, open_index, mega_menu = $(".hover-dropdown-menu");
  
  $(".with-mega-menu").on('mouseover', function () {
  		let index = $(".with-mega-menu").index(this);
    	//console.log(open_index, index);
    $(".with-mega-menu").removeClass("open-menu");
    $(this).addClass("open-menu");
    
    $(".menu-grid").addClass('hidden-menu');
    $(".menu-grid").eq(index).removeClass('hidden-menu');
    
    
    
    if (!menu_open) {     
     mega_menu.css({
        display: 'block',
        top: '20%'
      })
       
       let open_animated_object = {
       top: '100%',
       opacity: 1
     }
       
      	mega_menu.animate(open_animated_object, 400);
      
      menu_open = true;
    }
    
    
    open_index = index;
      
    
  })
  
  $(".header-wrapper").on('mouseleave', function () {
    if (menu_open) {
      hideMenu(true)
    }
  })
  
  let lastScrollPos = 0;

  $(window).on("scroll", function () {
    	let scrollPos = $(this).scrollTop();
    
    if (menu_open) {
   		if (scrollPos > 0 && scrollPos > lastScrollPos) {
         	hideMenu();
    	}
      
    }
    
    lastScrollPos = scrollPos;
  })
  
  $(".modal__toggle").click(function () {
    if (menu_open){ hideMenu(true); }
  })
  
  function hideMenu(with_animation = false) {
	let close_animated_object = {
        top: '80%',
        opacity: 0
      }
       
    if (with_animation) {
      mega_menu.animate(close_animated_object, 400, function () {
       		mega_menu.hide();
         	menu_open = false;
         	 $(".with-mega-menu").removeClass("open-menu");
       });
    } else{
      mega_menu.hide();
      menu_open = false;
      $(".with-mega-menu").removeClass("open-menu");
    }
       
}
})